<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="登录密码修改"
    width="46%"
    :before-close="beforeClose"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="true"
    class="pwd-edit"
  >
    <el-form
      label-width="100px"
      :rules="rules"
      :model="ruleForm"
      ref="ruleForm"
      @submit.native.prevent
    >
      <div class="rule-tip">
        温馨提示：
        为保障您的账号安全和数据安全，按照密码安全要求，系统的密码需设定为强口令密码，现密码规则要求：
        至少包含大写字母，小写字母，数字和特殊符号这四种，并且密码长度大于等于8位且小于等于30位；
      </div>
      <el-form-item label="原密码：" prop="originalPwd">
        <el-input
          v-model="ruleForm.originalPwd"
          type="password"
          autocomplete="new-password"
          placeholder="请输入原密码"
        />
      </el-form-item>
      <el-form-item label="新密码：" prop="newPwd">
        <el-input
          v-model="ruleForm.newPwd"
          type="password"
          autocomplete="off"
          placeholder="请输入新密码"
        />
      </el-form-item>
      <el-form-item label="确认密码：" prop="confirmPwd">
        <el-input
          v-model="ruleForm.confirmPwd"
          type="password"
          autocomplete="off"
          placeholder="请确认新密码"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="beforeClose">关 闭</el-button>
      <el-button type="primary" @click.native="submitPassword">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import utility from 'utility';
import { mapState } from "vuex";
import API from "@/api/common.js"; // 请求接口
import "element-ui/lib/theme-chalk/index.css";

export default {
  props: {
    dialogVisible: Boolean,
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
    closeUserDialog: Function,
  },
  data() {
    const validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原密码"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      // const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      // const reg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[~!@#$%^&*()_+`\-=_+|\\{}:";'<>?,.\\/])[a-zA-Z\d#@*&.].{7,29}$/;
      let matchCount = 0;
      const reg1 = /[a-z]/;
      const reg2 = /[A-Z]/;
      const reg3 = /[`~!@#$%^&*()\-_=+\\|[{}\]:";'<>?,./\s]/;
      const reg4 = /\d/;
      reg1.test(value) && matchCount++;
      reg2.test(value) && matchCount++;
      reg3.test(value) && matchCount++;
      reg4.test(value) && matchCount++;
      const otherReg = /^.{8,30}$/g;
      const otherRes = otherReg.test(value);
      otherReg.lastIndex = 0;
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (value === this.userInfo.userAccount) {
        callback(new Error("密码不能与账号名相同"));
      } else if (!otherRes) {
        callback(new Error("密码长度不能低于8位且不大于30位"));
      } else if (matchCount < 3) {
        callback(new Error("请输入正确格式的密码"));
      } else {
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        originalPwd: "",
        newPwd: "",
        confirmPwd: ''
      },
      rules: {
        originalPwd: [
          { required: true, validator: validateOldPass, trigger: "blur" },
        ],
        newPwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        confirmPwd: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    submitPassword() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            data: {
              params: {
                loginAccount: this.userInfo.loginAccount,
                loginPwd: this.ruleForm.newPwd, // 新密码
                oldPwd: this.ruleForm.originalPwd, // 旧密码
              },
            },
          };
          API.updateLoginPwdByLoginName(params, (callback) => {
            if (callback.status == "S") {
              this.$message.success("登录密码修改成功,请重新登录");
              let params = {
                gagauthtoken: localStorage.getItem("token"),
              };
              API.logout(params, (callback) => {
                if (callback.status == "S") {
                  window.clearVuexAlong();
                  this.$router.push("/login");
                }
              });
            } else {
            }
          });
        }
      });
    },
    beforeClose() {
      this.$refs.ruleForm.resetFields();
      this.closeUserDialog();
    },
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.ruleForm.originalPwd = "";
        this.ruleForm.newPwd = "";
        this.ruleForm.confirmPwd = "";
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.rule-tip
  line-height: 24px
  margin-bottom: 26px
  color: red
  .text
    color #222222
  .indent
    text-indent 2em
  em
    padding-right 1em
    font-style normal
    color red
.el-form
  margin 0 20%
</style>
